import { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'motion/react';
type PageTransitionProps = HTMLMotionProps<'div'>;
type PageTransitionRef = React.ForwardedRef<HTMLDivElement>;
function PageTransition({
  children,
  ...rest
}: PageTransitionProps, ref: PageTransitionRef) {
  return <motion.div ref={ref} initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    ease: 'easeInOut',
    duration: 0.5
  }} {...rest} data-sentry-element="unknown" data-sentry-component="PageTransition" data-sentry-source-file="PageTransition.tsx">
      {children}
    </motion.div>;
}
export default forwardRef(PageTransition);